module.exports = __webpack_public_path__ + "img/plat_du_jour.438d3368.png";